var _rect, _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditProfileIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F5F5F5"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_850_12878)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_850_12878",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 9,
    width: 23,
    height: 22
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.3887 9H8.38867V31H30.3887V9Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_850_12878)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.388 20.6872C16.4822 20.6872 14.1172 18.3222 14.1172 15.4163C14.1172 12.5105 16.4822 10.1455 19.388 10.1455C22.2939 10.1455 24.6589 12.5105 24.6589 15.4163C24.6589 18.3222 22.2939 20.6872 19.388 20.6872ZM19.388 11.5205C17.243 11.5205 15.4922 13.2713 15.4922 15.4163C15.4922 17.5613 17.243 19.3122 19.388 19.3122C21.533 19.3122 23.2839 17.5613 23.2839 15.4163C23.2839 13.2713 21.533 11.5205 19.388 11.5205Z",
    fill: "#002857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8896 29.8541C22.5413 29.8541 22.2113 29.7257 21.9729 29.4874C21.6888 29.2032 21.5604 28.7908 21.6246 28.3599L21.7988 27.1224C21.8446 26.8016 22.0371 26.4258 22.2663 26.1874L25.5112 22.9424C26.8129 21.6408 27.9588 22.3833 28.5179 22.9424C28.9946 23.4191 29.2421 23.9324 29.2421 24.4457C29.2421 24.9682 29.0038 25.454 28.5179 25.9399L25.2729 29.1849C25.0437 29.4141 24.6588 29.6066 24.3379 29.6524L23.1004 29.8265C23.027 29.8449 22.9629 29.8541 22.8896 29.8541ZM27.0054 23.5932C26.8404 23.5932 26.6937 23.7033 26.4829 23.9141L23.2379 27.1591C23.2104 27.1866 23.1645 27.2782 23.1645 27.3149L22.9996 28.4607L24.1454 28.2958C24.1821 28.2866 24.2737 28.2408 24.3012 28.2133L27.5463 24.9682C27.6929 24.8215 27.8671 24.6107 27.8671 24.4457C27.8671 24.3082 27.7571 24.1158 27.5463 23.9141C27.3263 23.6941 27.1612 23.5932 27.0054 23.5932Z",
    fill: "#002857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5659 26.6175C27.5017 26.6175 27.4375 26.6085 27.3825 26.5901C26.1725 26.251 25.21 25.2885 24.8709 24.0785C24.77 23.7118 24.9809 23.336 25.3475 23.2351C25.7142 23.1343 26.09 23.345 26.1909 23.7117C26.4017 24.4634 26.9975 25.0593 27.7492 25.2701C28.1159 25.371 28.3267 25.7559 28.2259 26.1134C28.1434 26.4159 27.8684 26.6175 27.5659 26.6175Z",
    fill: "#002857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5156 29.8542C11.1398 29.8542 10.8281 29.5425 10.8281 29.1667C10.8281 25.2525 14.669 22.0625 19.3898 22.0625C20.389 22.0625 21.379 22.2092 22.3048 22.4842C22.6715 22.5942 22.8732 22.9792 22.7632 23.3367C22.6532 23.7033 22.2682 23.905 21.9107 23.795C21.104 23.5567 20.2607 23.4283 19.3898 23.4283C15.4298 23.4283 12.2031 25.995 12.2031 29.1575C12.2031 29.5425 11.8915 29.8542 11.5156 29.8542Z",
    fill: "#002857"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_850_12878"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(9 9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditProfileIcon);
export default __webpack_public_path__ + "static/media/edit-profile-icon.05072e24f35ff41dea6b03f0d46d98f5.svg";
export { ForwardRef as ReactComponent };